var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.systemStarted === null)?_c('div',{staticClass:"loader"},[_c('loader-component',{attrs:{"size":"lg"}})],1):(_vm.systemStarted || _vm.$route.name === 'guardian')?_c('router-view'):_c('plug-component')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }